import React from 'react';
import classNames from 'classnames';
import { episodeNavigationClick } from '@wix/bi-logger-podcast/v2';
import IndexLink from '../../../../components/nav/IndexLink';
import { IWithI18nProps, withI18n } from '../../../../components/context/i18n';
import {
  withSettings,
  IWithSettingsProps,
} from '../../../../components/context/settings';

import LeftArrow from './LeftArrow';

import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';
import { biLogger } from '../../../../client/bi';

import getStyles from './Nav.styles';
import styles from './Nav.scss';

interface IEpisodePageNavIndexProps extends IWithI18nProps, IWithSettingsProps {
  episode: Pick<IPodcastEpisode, 'id'>;
  className: string;
}

function EpisodePageNavIndex({
  episode,
  t,
  settings,
  className,
}: IEpisodePageNavIndexProps) {
  const dynamicStyles = getStyles({
    colors: settings.colors.episode,
    fonts: settings.fonts.episode,
  });

  return (
    <IndexLink
      onClick={() => {
        biLogger.report(
          episodeNavigationClick({
            button: 'all',
            episodeId: episode && episode.id,
          }),
        );
      }}
      data-hook="episode.header.link-all-episodes"
      className={classNames(
        styles.allEpisodes,
        dynamicStyles.allEpisodes,
        className,
      )}
    >
      <LeftArrow className={styles.leftArr} />
      <div className={styles.text}>{t('pages.episode.link-all-episodes')}</div>
    </IndexLink>
  );
}

export default withSettings(withI18n(EpisodePageNavIndex));
